import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import moment from "moment";

import { refreshBucketStatus } from "../../modules/sources";
import { Popper } from "@mui/material";

const StorageDownloadCdnTooltip = ({
    target,
    id,
    type,
    data,
    indexingState,
    indexingRequestedAt,
    indexingCompletedAt,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();

    const open = Boolean(anchorEl);
    const tooltipId = open ? "simple-popper" : undefined;

    const handleClick = (e) => {
        setAnchorEl(anchorEl ? null : e.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
    };

    return (
        <div className="popper-tooltip" onMouseLeave={handleClose}>
            <span aria-describedby={tooltipId} onClick={(e) => handleClick(e)} onMouseEnter={(e) => handleClick(e)}>
                <i className={"sprite sprite-cdn"} />
            </span>
            <Popper id={tooltipId} open={open} anchorEl={anchorEl} placement={type ? "bottom-start" : "bottom"}>
                <div className="tooltip-small">
                    {t(
                        `common::msg::${"It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file."}`,
                    )}
                    {/*현재 위치에서 멀리 떨어진 곳(해외)에서 파일을 다운로드 받거나 대용량 파일을 다운로드 하기 때문에 안정적인 처리에 다소 시간이 소요될 수 있습니다.*/}
                </div>
            </Popper>
        </div>
    );
};
StorageDownloadCdnTooltip.propTypes = {
    target: PropTypes.object,
    id: PropTypes.string,
    type: PropTypes.string,
};

export default StorageDownloadCdnTooltip;
